import type { CorrectComponentType } from "@brytdesigns/web-component-core/utils";
import { type Format } from "../utils/index.js";

import { Show } from "solid-js";

import {
  type CartPath,
  useCartPath,
  useCartFormattedValue,
} from "../hooks/index.js";
import html from "solid-js/html";

export type Props = {
  propertyName: CartPath;
  format?: Format;
};

export const Name = "cart-data";

export const Component: CorrectComponentType<Props> = (props, { element }) => {
  if (!props.propertyName)
    return console.warn(`${Name}: No property-name attribute provided.`);
  const fullPath = useCartPath({
    element,
    path: () => props.propertyName,
  });
  const formattedValue = useCartFormattedValue({
    get format() {
      return props.format;
    },
    path: fullPath,
    element,
  });

  return html`
    <${Show} when=${() => formattedValue() !== null}> ${formattedValue} <//>
  `;
};
